module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a6-4-a774e69a7d438bf5c4784b477ca2c0a3.jpg";